import { render, staticRenderFns } from "./DataTableDialog.vue?vue&type=template&id=5d6c5ad2"
import script from "./DataTableDialog.vue?vue&type=script&lang=js"
export * from "./DataTableDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports